import api from "../../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    cancelReasons: [],
  },
  getters: {
    getCancelReasons(state) {
      return state.cancelReasons;
    },
  },
  mutations: {
    SetCancelReasons(state, data) {
      state.cancelReasons = [];
      state.cancelReasons = data;
    },
  },
  actions: {
    getCancelReasons({ commit }) {
      return new Promise((resolve, rej) => {
      api()
        .post(
          `cancelReasons/getCancelReasons`,
          {},
          {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
        )
        .then((res) => {
          resolve(res);
          commit("SetCancelReasons", res.data);
        })
        .catch((err) => console.log(err));})
    },


    addCancelReason({ dispatch }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `cancelReasons/addCancelReason`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    editCancelReason(
      { dispatch },
      data
    ) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `cancelReasons/editCancelReason`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);

          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },

    deleteCancelReason({ dispatch }, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `cancelReasons/deleteCancelReason`,
            { id: id },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);

          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
  },
};
